export const loginIMG = process.env.REACT_APP_IMG_LOGIN